/*
 * Copyright © 2022 EPO: European Patent Office.
 * ALL RIGHTS RESERVED
 */

import React from 'react';
import { TableHead, TableRow } from '@material-ui/core';
import useStyles from './FOTableHeadStyle';
import { CELL_TYPES } from '../foTableBuilder/FOCellTypes';
import FOHeadCombinedCell from './HeadCells/FOHeadCombineCell';
import FOHeadActionCell from './HeadCells/FOHeadActionCell';
import FOHeadCell from './HeadCells/FOHeadCell';
import FOHeadCheckCell from './HeadCells/FOHeadCheckCell';
import { useScreenSize } from '../../../shared/theming/useScreenSize';

export default function FOTableHead({ columns, isAllSelected, handleSelectAll, getSortOrderForColumn, onClickColumn }) {
  const classes = useStyles();
  // const { isAllSelected, handleSelectAll, getSortOrderForColumn, onClickColumn } = useContext(DraftManagementContext);
  const screenSize = useScreenSize();
  return (
    <TableHead>
      <TableRow className={classes.tableHeadCell}>
        {columns?.map((cellData, index) => {
          if (cellData?.type === CELL_TYPES.SELECT_ALL) {
            return (
              <FOHeadCheckCell
                key={index}
                isAllSelected={isAllSelected}
                handleSelectAll={handleSelectAll}
                data={cellData}
              />
            );
          }
          if (
            cellData?.type === CELL_TYPES.DEFAULT ||
            cellData?.type === CELL_TYPES.STATUS ||
            cellData?.type === CELL_TYPES.INVITATION_STATUS ||
            cellData?.type === CELL_TYPES.ROLES
          ) {
            return (
              <FOHeadCell
                key={index}
                data={cellData}
                onClickCell={onClickColumn}
                getSortOrderForColumn={getSortOrderForColumn}
              />
            );
          }
          if (cellData?.type === CELL_TYPES.COMBINED) {
            return (
              <FOHeadCombinedCell key={index} data={cellData} className={cellData?.className} screenSize={screenSize} />
            );
          }
          if (cellData?.type === CELL_TYPES.ACTION) {
            return <FOHeadActionCell key={index} data={cellData} />;
          }
          return null;
        })}
      </TableRow>
    </TableHead>
  );
}
